
































import Vue from 'vue';

export default Vue.extend({
  name: 'App',

  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    },
  },
});
